import { render, staticRenderFns } from "./WelcomeView.vue?vue&type=template&id=2060c6f8"
import script from "./WelcomeView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WelcomeView.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports